import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "42",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#248096",
  stroke: "#fff",
  "stroke-width": "2",
  d: "m18.153 40.617-.057.042c-.427.317-.94.38-1.352.321s-.885-.261-1.205-.682l-.003-.004L4.209 25.59l-.001-.001C2.165 22.946 1 19.759 1 16.382 1 7.854 8.239 1 17 1s16 6.854 16 15.382c0 3.376-1.165 6.564-3.208 9.207zm0 0 .051-.05.167-.167.048-.047.04-.052 11.332-14.71z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M21.913 14.404V9.589a.793.793 0 0 0-.794-.795H19.53A.793.793 0 0 0 18.736 8h-3.97a.793.793 0 0 0-.795.794h-1.588a.793.793 0 0 0-.795.795v4.815L10 15.148l1.588 3.177v1.588l2.532.745a.8.8 0 0 0 .248.05c.084 0 .175-.028.248-.05l2.135-.745 2.135.745c.082.027.164.05.248.05s.17-.026.248-.05l2.532-.745v-1.588l1.587-3.177zm-1.588-.745-2.78-1.29-.794-.398-.794.397-2.78 1.291v-3.276h7.148zM11.588 21.502a.8.8 0 0 0-.248.05l-1.34.446v1.614l1.588-.522 2.532.746a.8.8 0 0 0 .248.049.9.9 0 0 0 .248-.05l2.135-.745 2.135.746a.8.8 0 0 0 .248.049c.084 0 .17-.025.248-.05l2.532-.745 1.587.522.001-1.614-1.34-.447a.8.8 0 0 0-.248-.049.8.8 0 0 0-.249.05l-2.531.744-2.135-.745a.8.8 0 0 0-.248-.049.9.9 0 0 0-.248.05l-2.135.744-2.531-.745a.6.6 0 0 0-.249-.049"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }